/* import __COLOCATED_TEMPLATE__ from './prism-external-click-handler.hbs'; */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { bind } from '@ember/runloop';

// TODO: Refactor to a modifier once we are on Ember Octane!
export default Component.extend({
  tagName: '',
  onExternalClick() {},
  targetElement: null,
  eventNames: computed(function () {
    return ['click', 'touchend'];
  }),
  didInsertElement() {
    this._boundFunction = bind(this, this._handleEvent);
    this.eventNames.forEach(eventName => {
      window.addEventListener(eventName, this._boundFunction);
    });
  },
  willDestroyElement() {
    if (this._boundFunction) {
      this.eventNames.forEach(eventName => {
        window.removeEventListener(eventName, this._boundFunction);
      });
      this._boundFunction = undefined;
    }
  },
  _handleEvent(event) {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    const isExternalClickOrTouch = !this.targetElement.contains(event.target);
    if (isExternalClickOrTouch) {
      this.onExternalClick();
    }
  }
});